import React from 'react';
import LegalDocument from '../components/page/LegalDocument';
import {
  termsOfServiceMeta,
  termsOfServiceArticles,
  termsOfServiceContact,
  termsOfServiceEstablishedDate,
} from '../data/termsOfService';
import usePageMeta from '../lib/usePageMeta';
import { PAGE_META } from '../data/pageMeta';

const TermsOfService = () => {
  usePageMeta(PAGE_META.termsOfService);
  return (
    <LegalDocument
      label={termsOfServiceMeta.label}
      title={termsOfServiceMeta.title}
      lead={termsOfServiceMeta.lead}
      articles={termsOfServiceArticles}
      contact={termsOfServiceContact}
      establishedDate={termsOfServiceEstablishedDate}
      accent="blue"
    />
  );
};

export default TermsOfService;
